import React, { useEffect, useState } from 'react';
import Header from './Header';
import Sidebar from './Sidebar';
import { useNavigate } from 'react-router-dom';
import CreateMetroNonServiceable from '../Components/CreateMetroNonServiceable';

const CreateMetroNonServiceableAdmin = () => {
    const navigate = useNavigate();
    const [userlog, setUserlog] = useState(localStorage.getItem('Logkey'));
    useEffect(() => {
        if (userlog === undefined || userlog === null) {
            navigate("/")
        }
    }, [])

    return (
        <>
            <Header />
            <Sidebar />
            <CreateMetroNonServiceable />
            {/* <Footer/>   */}
        </>
    )
}

export default CreateMetroNonServiceableAdmin
